import { render, staticRenderFns } from "./GCodesPage.vue?vue&type=template&id=de2665e8&scoped=true&"
import script from "./GCodesPage.vue?vue&type=script&lang=js&"
export * from "./GCodesPage.vue?vue&type=script&lang=js&"
import style0 from "./GCodesPage.vue?vue&type=style&index=0&id=de2665e8&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de2665e8",
  null
  
)

export default component.exports